import { Icon } from "./Icon";

interface GraphStatusProps {
  error?: string | null;
  onRetry?: () => void;
}

export function GraphStatus({ error, onRetry }: GraphStatusProps) {
  return (
    <main className="status-screen">
      <div className="status-brand">
        <span>JH</span>
        <span aria-hidden="true">/</span>
        <span>SECOND BRAIN</span>
      </div>
      <div className="status-content" role={error ? "alert" : "status"}>
        <span className={`status-icon${error ? " is-error" : ""}`}>
          <Icon name={error ? "alert" : "brain"} size={22} />
        </span>
        <h1>{error ? "연결을 불러오지 못했습니다" : "생각의 연결을 불러오는 중"}</h1>
        <p>{error ?? "공개된 노드와 관계를 안전하게 구성하고 있습니다."}</p>
        {error && onRetry ? (
          <button className="status-retry" onClick={onRetry} type="button">
            다시 시도
          </button>
        ) : null}
      </div>
    </main>
  );
}
